import React from "react";
import { AspectRatio, Box, Paper, Stack, Text, Title } from "@mantine/core";
import { last } from "lodash";
import { useTranslation } from "react-i18next";
import CPTGazeViewerComponent from "../../../../../../testContainer/common/CPTGazeViewerComponent";
import CPTTestBackground from "../../../../../../testContainer/common/CPTTestBackground";
import { cptStimuliListForResultsPage } from "@constants/testConstants/testSpecificConstants/continuousPerformanceConstants";
import { PercentagePoint, Stimulus } from "types/testTypes";

interface CPTGazeHeatmapSectionProps {
  isForAdult: boolean;
  gazePercentageData?: PercentagePoint[] | null;
  stimuli?: Stimulus[] | null;
  isForResultsPage?: boolean;
  percentShown?: number;
}

const CPTGazeHeatmapSection: React.FC<CPTGazeHeatmapSectionProps> = ({
  isForAdult,
  gazePercentageData,
  stimuli,
  isForResultsPage,
  percentShown = 100,
}) => {
  const { t } = useTranslation();
  const hasGazeSamples = !!gazePercentageData?.length;

  return (
    <Paper p="xl">
      <Stack gap="md">
        <Title order={6} ta="start">
          {t("extraTests.continuousPerformance.heatMapTitle")}
        </Title>
        <AspectRatio ratio={16 / 9}>
          <Box display="grid" style={{ placeItems: "center" }}>
            <CPTTestBackground
              isForAdult={isForAdult}
              stimuli={
                isForResultsPage
                  ? cptStimuliListForResultsPage
                  : last(stimuli)
                    ? [last(stimuli) as Stimulus]
                    : []
              }
              style={{ gridArea: "1 / 1", zIndex: 1 }}
            />
            {hasGazeSamples ? (
              <CPTGazeViewerComponent
                isForResultsPage={isForResultsPage}
                snapshots={gazePercentageData}
                percentShown={percentShown}
                style={{ gridArea: "1 / 1", zIndex: 1 }}
              />
            ) : (
              <Box
                style={{
                  gridArea: "1 / 1",
                  zIndex: 2,
                  display: "grid",
                  placeItems: "center",
                  pointerEvents: "none",
                }}
              >
                <Text size="sm" c="dimmed" fw={500}>
                  {t("extraTests.continuousPerformance.result.aggregateHeatmap.noSession")}
                </Text>
              </Box>
            )}
          </Box>
        </AspectRatio>
      </Stack>
    </Paper>
  );
};

export default CPTGazeHeatmapSection;
